import gql from 'graphql-tag'

const REMOVE_CART_ITEM = gql`
  mutation ($id: String!) {
    removeCartItem(id: $id) {
      id
    }
  }
`

const UPDATE_CART_ITEM = gql`
  mutation ($id: String!, $quantity: Int) {
    updateCartItem(id: $id, quantity: $quantity) {
      id
      quantity
    }
  }
`

export {
  REMOVE_CART_ITEM,
  UPDATE_CART_ITEM
}
